import React from 'react'

const Home = () => {
  return (
    <div className='p-0 m-0 overflow-auto bg-[#161B31] h-[100%]'>
      this is the content
    </div>
  )
}

export default Home
